"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.omitUndefined = exports.omitNull = exports.omitNil = void 0;

var _fp = require("lodash/fp");

var omitUndefined = function omitUndefined(o) {
  return (0, _fp.omitBy)(_fp.isUndefined, o);
};

exports.omitUndefined = omitUndefined;

var omitNull = function omitNull(o) {
  return (0, _fp.omitBy)(_fp.isNull, o);
};

exports.omitNull = omitNull;

var omitNil = function omitNil(o) {
  return (0, _fp.omitBy)(_fp.isNil, o);
};

exports.omitNil = omitNil;